module.exports = __webpack_public_path__ + "img/2-(3).e09a471a.jpg";